// extracted by mini-css-extract-plugin
module.exports = {"shopping-cart":"ShoppingCart_shopping-cart__YLKCr"};